import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";

export class CryptoproController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}

	getSignerCertificate = this.api.jcp.signatureSignerCreate
}
